<template>
  <div ref="CAudioBg" class="audio-bg" :style="customStyle">
    <div class="btn-control" @click="onClickControll">
      <a-icon v-if="isPlaying" type="pause-circle" />
      <a-icon v-else type="play-circle" />
    </div>
    <span v-if="isSmall" key="smallTag">{{timeCount}}</span>
    <span v-else key="longTag">{{currentTime + '/' + totalTime}}</span>
    <audio
      ref="customAudio"
      @pause="onPause"
      @play="onPlay"
      @loadedmetadata="onLoadedmetadata"
      @timeupdate="onTimeUpdate"
      preload="none"
      alt="audio"
      :src="audioUrl"
    />
  </div>
</template>

<script>
export default {
  props: {
    audioUrl: {
      type: String,
      required: true,
    },
    customStyle: {
      type: Object,
      default: () => {
        return {
          backgroundColor: "#1890ff",
          color: "#fff"
        }
      }
    }
  },
  data() {
    return {
      isPlaying: false,
      timeCount: "",
      currentTime: "00",
      totalTime: "00",
      totalSeconds: 0,
      isSmall: false,
    };
  },
  created() {},
  mounted() {
    const element = this.$refs.CAudioBg.getBoundingClientRect()
    this.isSmall = element.width < 90;
  },
  methods: {
    onPause(){
      this.isPlaying = false;
    },
    onPlay(){
      this.isPlaying = true;
    },
    onClickControll() {
      if (this.isPlaying) {
        this.$refs.customAudio.pause()
      } else {
        this.$refs.customAudio.play();
      }
    },
    onTimeUpdate(res) {
      this.currentTime = this.formatSeconds(parseInt(res.target.currentTime))
      this.timeCount = this.formatSeconds(this.totalSeconds - parseInt(res.target.currentTime))
    },
    onLoadedmetadata(res) {
      this.totalSeconds  = parseInt(res.target.duration)
      this.timeCount = this.totalTime = this.formatSeconds(parseInt(res.target.duration))
    },
    formatSeconds(seconds) {
      const secType = typeof seconds;
      if(secType === "number" || secType === "string") {
        seconds = parseInt(seconds);
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const second = Math.floor(seconds % 60);
        if(hours === 0) {
          return `${minutes}:${second}`
        } else {
          return `${hours}:${minutes}:${second}`
        }
      }
    }
  },
};
</script>

<style lang="less"scoped>
.audio-bg {
  margin: auto;
  padding: 5px 10px;
  border-radius: 8px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  user-select: none;
  .btn-control {
    font-size: 22px;
    display: flex;
    align-items: center;
    margin-right: 10px;
  }
}
</style>
